export default __webpack_public_path__ + "static/media/Guilherme.3712c8b6.mp4";